import React from "react";
import { Skeleton, Tab, Tabs } from "@mui/material";

import { tabSx } from "./curriculumTabsABP.utils";

export enum TabIndex {
  CURRICULUM_NACIONAL = 0,
  OBJETIVOS_ORGANIZACION = 1,
  TECNICO_PROFESIONAL = 2,
}

interface Props {
  tabValue: TabIndex;
  onChange: (event: React.SyntheticEvent, newValue: TabIndex) => void;
  allowedTP: boolean;
  isLoadingTPInfo: boolean;
  borderColor: string;
}

export default function CurriculumTabsABPHeader({
  tabValue,
  onChange,
  allowedTP,
  isLoadingTPInfo,
  borderColor,
}: Props) {
  return (
    <Tabs
      value={tabValue}
      onChange={onChange}
      aria-label="Tabs currículum"
      sx={{
        borderBottom: `1px solid ${borderColor}`,
        minHeight: 0,
        "& .MuiTabs-flexContainer": { alignItems: "flex-end" },
        "& .MuiTabs-indicator": { display: "none" },
      }}
    >
      <Tab
        value={TabIndex.CURRICULUM_NACIONAL}
        label="Currículum Nacional"
        disableRipple
        sx={() => tabSx(tabValue === TabIndex.CURRICULUM_NACIONAL)}
      />

      <Tab
        value={TabIndex.OBJETIVOS_ORGANIZACION}
        label="Objetivos de organización"
        disableRipple
        sx={() => tabSx(tabValue === TabIndex.OBJETIVOS_ORGANIZACION)}
      />

      {isLoadingTPInfo ? (
        <Tab
          value={TabIndex.TECNICO_PROFESIONAL}
          disabled
          icon={
            <Skeleton
              variant="rounded"
              width={140}
              height={18}
              sx={{ borderRadius: 999 }}
            />
          }
          iconPosition="start"
          label=""
          disableRipple
          sx={{
            minHeight: 0,
            py: 1.2,
            px: 2.5,
            mr: 0.4,
            borderTopLeftRadius: 8,
            borderTopRightRadius: 8,
            color: "#1D3D4D",
            opacity: 1,
            "&.Mui-disabled": { opacity: 1 },
          }}
        />
      ) : (
        allowedTP && (
          <Tab
            value={TabIndex.TECNICO_PROFESIONAL}
            label="Técnico Profesional"
            disableRipple
            sx={() => tabSx(tabValue === TabIndex.TECNICO_PROFESIONAL)}
          />
        )
      )}
    </Tabs>
  );
}
